module.exports = __webpack_public_path__ + "img/public/siteImages/noSearchResult.png?57a810f2";